import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2de6547b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main !tw-overflow-x-hidden tw-flex tw-flex-col tw-justify-start" }
const _hoisted_2 = { class: "xl:tw-px-[60px] xl:tw-pt-[41px] xl:tw-pb-[55px] tw-flex-1 tw-flex tw-flex-col tw-border-[1px] tw-border-[#EFF0F1] tw-border-solid tw-px-[10px] tw-py-[40px]" }
const _hoisted_3 = { class: "tw-flex tw-gap-[20px] tw-justify-end tw-items-center" }

import AppBarLayout from "@/components/layouts/appBarLayout.vue";
import ActivePathWrapper from "@/components/common/activePathWrapper.vue";
import { getComponentUiText } from "@/utils/utilities";
import Button1 from "@/components/common/button1.vue";
import VendorQuestionCreatePage from "@/components/vendor/vendorQuestionCreatePage.vue";
import VendorCreateTemplate from "@/components/vendor/vendorCreateTemplate.vue";
import { useRoute } from "vue-router";
import { computed, onMounted, ref } from "vue";
import EventEmitter, { EmitterEvents } from "@/utils/eventEmitter";
import store from "@/store";
import router from "@/router";
import { MODAL_NAME } from "@/utils/constants";


export default /*#__PURE__*/_defineComponent({
  __name: 'vendorAssessmentsCreate',
  props: {
  isEnableButton: {
    type: Boolean,
    default: false,
  },
},
  setup(__props) {

const props = __props;



const route = useRoute();
const isEdit = computed(() => {
  return route.query.isEdit === "true";
});

const templateId: any = computed(() => {
  return route.query.templateId;
});

const isLoading = ref(false);
const isUpdateChecklistRequested = ref(false);
const isShowButton = computed(() => store.state.Vendor.isShowButton);
const vendorCreateTemplateRef = ref<any>(null);
const vendorQuestionCreatePageRef = ref<any>(null);
const isBtnLoading = ref(false);
const isBtn2Loading = ref(false);

const isUpdateQuestion = computed(
  () => store.state.Vendor.isUpdateQuestionItem,
);
const templateEditId = computed(() => store.state.Vendor?.templateEditId);
const isExitsTemplateName = computed(
  () => store.state.Vendor.isExitsTemplateName,
);

const isCheckQuestionInTemplate = computed(
  () => store.getters["Vendor/isCheckQuestionInTemplate"],
);

onMounted(() => {
  if (route.query.templateId) {
    fetchRequestedTemplateDetail();
  }
});

const fetchRequestedTemplateDetail = async () => {
  isLoading.value = true;

  await store.dispatch("Vendor/fetchRequestedTemplateDetail", {
    templateId: route.query.templateId,
  });

  isLoading.value = false;
};
const isSubmit = computed(() => store.state.Vendor.isShowButton);

const onSubmit = async () => {
  isBtnLoading.value = true;
  await new Promise((resolve) => setTimeout(resolve, 500));
  if (!templateEditId.value) {
    await vendorCreateTemplateRef.value.createTemplate();
  }
  await vendorQuestionCreatePageRef.value.submitQuestion();
  if (isUpdateChecklistRequested.value) {
    setTimeout(() => {
      isBtnLoading.value = false;
      router.push({ path: "/assess/vendor/manage" });
    }, 500);
  }
};

const onSaveAndClose = async () => {
  isLoading.value = true;
  if (!templateEditId.value) {
    await vendorCreateTemplateRef.value.createTemplate();
  }
  await vendorQuestionCreatePageRef.value.submitQuestion();
  if (isUpdateChecklistRequested.value) {
    setTimeout(() => {
      isLoading.value = false;
      router.push({ path: "/assess/vendor/manage" });
    }, 500);
  }
};
const checkUpdateApi = (val) => {
  isLoading.value = false;
  isBtnLoading.value = false;
  isUpdateChecklistRequested.value = val;
};

const onUseTemplate = (templateId) => {
  isBtn2Loading.value = true;
  setTimeout(() => {
    isBtn2Loading.value = false;
  }, 500);
  router.push({ path: "/assess/vendor/manage" });
  setTimeout(() => {
    const emitData = {
      component: MODAL_NAME.MODAL_CREATE_NEW_VENDOR_ASSESSMENT,
      properties: {
        value: {},
        title: "",
        description: "",
        buttonText: "",
        buttonRed: false,
        slotCustom: "",
        list: [],
        hiddenHelp: "",
        templateId: Number(templateId),
      },
      events: {
        "update:data": () => {},
        "update:close": () => {},
      },
    };
    EventEmitter.emit(EmitterEvents.OPEN_MODAL, emitData);
  }, 500);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(AppBarLayout, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(ActivePathWrapper, {
          "active-hierarchy": [
            _unref(getComponentUiText)('app-menu-assess-1'),
            _unref(getComponentUiText)('app-menu-submenu-assess-vendor-assessments-1'),
            isEdit.value
              ? _unref(getComponentUiText)(
                  'app-assessment-vendor-edit-template-title-1',
                )
              : _unref(getComponentUiText)(
                  'app-assessment-vendor-create-template-title-1',
                ),
          ],
          "button-title": 
            _unref(getComponentUiText)(
              'app-menu-submenu-assess-vendor-assessments-save-vs-close-button-title-1',
            )
          ,
          "button2-title": 
            _unref(getComponentUiText)(
              'app-assessments-vendor-assessment-use-template-button-1',
            )
          ,
          "is-outline": true,
          "is-outline2": false,
          navigate: ['', '/assess/vendor/manage', '', ''],
          "id-button1": "vendor-assess-template-save",
          "id-button2": "vendor-assess-template-use-template",
          "data-cy1": "vendor-assess-template-save-and-close-btn",
          "data-cy2": "vendor-assess-template-use-template-btn",
          "is-button2-enable": !isCheckQuestionInTemplate.value,
          "is-btn-loading": isBtnLoading.value,
          "is-btn2-loading": isBtn2Loading.value,
          onClickButton: onSubmit,
          onClickButton2: _cache[0] || (_cache[0] = ($event: any) => (onUseTemplate(_unref(route).query.templateId)))
        }, null, 8, ["active-hierarchy", "button-title", "button2-title", "is-button2-enable", "is-btn-loading", "is-btn2-loading"]),
        _createVNode(VendorCreateTemplate, {
          id: "vendor-assess-template",
          ref_key: "vendorCreateTemplateRef",
          ref: vendorCreateTemplateRef,
          "is-edit": isEdit.value,
          "template-id": templateId.value,
          "is-loading": isLoading.value,
          onIsCallUpdate: checkUpdateApi
        }, null, 8, ["is-edit", "template-id", "is-loading"]),
        _createElementVNode("div", _hoisted_2, [
          _createVNode(VendorQuestionCreatePage, {
            ref_key: "vendorQuestionCreatePageRef",
            ref: vendorQuestionCreatePageRef,
            onIsCallUpdate: checkUpdateApi
          }, null, 512),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(Button1, {
              id: "vendor-assess-template-btn-save",
              "data-cy": "vendor-assess-template-save-and-close-btn-bottom",
              class: _normalizeClass(`tw-min-w-[136px] !tw-h-[39.5px] button button-outline`),
              title: 
                _unref(getComponentUiText)(
                  'app-menu-submenu-assess-vendor-assessments-save-vs-close-button-title-1',
                )
              ,
              disabled: false,
              "is-loading": isLoading.value,
              onClick: _cache[1] || (_cache[1] = () => onSaveAndClose())
            }, null, 8, ["title", "is-loading"]),
            _createVNode(Button1, {
              id: "vendor-assess-template-btn-use-template",
              class: _normalizeClass(`button`),
              disabled: !isCheckQuestionInTemplate.value,
              title: 
                _unref(getComponentUiText)(
                  'app-assessments-vendor-assessment-use-template-button-1',
                )
              ,
              onClick: _cache[2] || (_cache[2] = () => onUseTemplate(_unref(route).query.templateId))
            }, null, 8, ["disabled", "title"])
          ])
        ])
      ])
    ]),
    _: 1
  }))
}
}

})